// extracted by mini-css-extract-plugin
module.exports = {"paged":"_11lbT"};